import React, { ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { PATHPICK_LANDING_COLORS } from "@/features/pathpick/features/landing/constants";

interface Props {
  // 섹션 제목 — h2로 낸다(h1은 히어로 하나뿐이다).
  title?: ReactNode;
  description?: string;
  children: ReactNode;
  hasTopDivider?: boolean;
}

/**
 * 랜딩 섹션 공통 껍데기 — 최대 폭, 좌우 여백, 제목/설명 간격을 한 곳에서 잡는다.
 */
function PathPickLandingSection({
  title,
  description,
  children,
  hasTopDivider = true,
}: Props) {
  return (
    <Flex
      as={"section"}
      justifyContent={"center"}
      paddingX={{ base: "20px", lg: "40px" }}
      paddingY={{ base: "44px", lg: "64px" }}
      borderTop={
        hasTopDivider ? `1px solid ${PATHPICK_LANDING_COLORS.border}` : undefined
      }
    >
      <Flex
        flexDirection={"column"}
        gap={{ base: "24px", lg: "32px" }}
        width={"100%"}
        maxWidth={"1120px"}
      >
        {(title || description) && (
          <Flex flexDirection={"column"} gap={"10px"}>
            {title && (
              <Text
                as={"h2"}
                textStyle={"body-lg-bold"}
                fontSize={{ base: "24px", lg: "30px" }}
                lineHeight={{ base: "34px", lg: "42px" }}
                color={PATHPICK_LANDING_COLORS.textStrong}
                whiteSpace={"pre-line"}
              >
                {title}
              </Text>
            )}
            {description && (
              <Text
                textStyle={"body-md-regular"}
                fontSize={{ base: "15px", lg: "16px" }}
                color={PATHPICK_LANDING_COLORS.textMuted}
              >
                {description}
              </Text>
            )}
          </Flex>
        )}
        {children}
      </Flex>
    </Flex>
  );
}

export default PathPickLandingSection;
